import { useState, useEffect } from 'react';

export function useScrollHysteresis(
  collapseThreshold: number,
  showThreshold: number,
  delay = 50 // ms delay buffer
) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Clear any pending state change
      if (timeoutId) clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setIsCollapsed((prev) => {
          if (!prev && scrollY > collapseThreshold) return true;  // collapse
          if (prev && scrollY < showThreshold) return false;       // expand
          return prev; // no change
        });
      }, delay);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [collapseThreshold, showThreshold, delay]);

  return isCollapsed;
}

